module.exports = __webpack_public_path__ + "img/mp.75ab0606.jpg";